import axios from 'axios'

const ApprovalService = {
  async get (params = {}) {
    return axios.get('scm/purchase-order/request-approvals', { params })
  },

  async histories (params = {}) {
    return axios.get('scm/reports/purchase-order/approval-histories', { params })
  },

  async show (id) {
    return axios.get(`scm/purchase-order/request-approvals/${id}`)
  },

  async post (params = {}) {
    return axios.post('scm/purchase-order/request-approvals', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`scm/purchase-order/request-approvals/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`scm/purchase-order/request-approvals/${data.id}`, { data })
  }
}

export default ApprovalService
